import type { CardPreviewAudit } from "./types";

export const sampleAudit: CardPreviewAudit = {
  requestedUrl: "https://example.com/launch",
  finalUrl: "https://example.com/launch",
  hostname: "example.com",
  checkedAt: "2026-06-14T09:00:00.000Z",
  score: 88,
  scoreLabel: "Share-ready",
  fetch: {
    requestedUrl: "https://example.com/launch",
    finalUrl: "https://example.com/launch",
    hostname: "example.com",
    status: 200,
    ok: true,
    contentType: "text/html; charset=utf-8",
    elapsedMs: 212,
    redirected: false,
    redirectChain: ["https://example.com/launch"],
    error: ""
  },
  tags: {
    title: "Launch Guide for Static Site Operators",
    description: "A practical guide to publishing a fast static site with clean metadata and share cards.",
    canonical: "https://example.com/launch",
    ogTitle: "Launch Guide for Static Site Operators",
    ogDescription: "A practical guide to publishing a fast static site with clean metadata and share cards.",
    ogImage: "https://example.com/images/launch-card.jpg",
    ogUrl: "https://example.com/launch",
    ogType: "article",
    ogSiteName: "Example Studio",
    ogLocale: "en_US",
    twitterCard: "summary_large_image",
    twitterTitle: "Launch Guide for Static Site Operators",
    twitterDescription: "A practical guide to publishing a fast static site with clean metadata and share cards.",
    twitterImage: "https://example.com/images/launch-card.jpg",
    twitterSite: "@example"
  },
  image: {
    url: "https://example.com/images/launch-card.jpg",
    status: 200,
    ok: true,
    contentType: "image/jpeg",
    bytes: 186240,
    width: 1200,
    height: 630,
    ratio: "1.90:1",
    https: true,
    error: ""
  },
  checks: [
    {
      key: "fetch",
      group: "Fetch",
      label: "Public fetch",
      level: "pass",
      value: "200",
      detail: "The page returned a successful public response.",
      points: 10
    },
    {
      key: "og",
      group: "Open Graph",
      label: "Core OG tags",
      level: "pass",
      value: "4/4 core tags",
      detail: "Open Graph expects title, type, image, and canonical object URL for rich social objects.",
      points: 35
    },
    {
      key: "image",
      group: "Image",
      label: "Preview image",
      level: "pass",
      value: "1200x630",
      detail: "The image is reachable and meets a common large-card size target.",
      points: 25
    },
    {
      key: "twitter",
      group: "Twitter",
      label: "Twitter/X card",
      level: "pass",
      value: "summary_large_image",
      detail: "Twitter/X card metadata is present.",
      points: 15
    },
    {
      key: "page",
      group: "Page",
      label: "Page metadata",
      level: "warn",
      value: "2/3 basics",
      detail: "HTML title, meta description, and canonical URL help non-OG consumers and debugging tools.",
      points: 9
    }
  ],
  issues: [
    {
      level: "warn",
      group: "Page",
      title: "Page metadata",
      detail: "HTML title, meta description, and canonical URL help non-OG consumers and debugging tools."
    }
  ],
  generated: {
    meta:
      '<meta property="og:title" content="Launch Guide for Static Site Operators">\n<meta property="og:description" content="A practical guide to publishing a fast static site with clean metadata and share cards.">\n<meta property="og:type" content="article">\n<meta property="og:url" content="https://example.com/launch">\n<meta property="og:image" content="https://example.com/images/launch-card.jpg">\n<meta property="og:site_name" content="Example Studio">\n<meta name="twitter:card" content="summary_large_image">\n<meta name="twitter:title" content="Launch Guide for Static Site Operators">\n<meta name="twitter:description" content="A practical guide to publishing a fast static site with clean metadata and share cards.">\n<meta name="twitter:image" content="https://example.com/images/launch-card.jpg">',
    markdown:
      "# CardSight report for example.com\n\n- Checked URL: https://example.com/launch\n- Suggested title: Launch Guide for Static Site Operators\n- Suggested image: https://example.com/images/launch-card.jpg\n\n## Copy-ready meta tags"
  },
  summary: {
    passes: 4,
    warnings: 1,
    failures: 0,
    informational: 0
  }
};
